import { render, staticRenderFns } from "./Advisor.vue?vue&type=template&id=cb82750a&"
import script from "./Advisor.vue?vue&type=script&lang=js&"
export * from "./Advisor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/lifecheq/htdocs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cb82750a')) {
      api.createRecord('cb82750a', component.options)
    } else {
      api.reload('cb82750a', component.options)
    }
    module.hot.accept("./Advisor.vue?vue&type=template&id=cb82750a&", function () {
      api.rerender('cb82750a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/Calculators/MyCover/Summaries/Tabs/Advisor.vue"
export default component.exports